import { render, staticRenderFns } from "./BaseStatusIcon.vue?vue&type=template&id=63f352e2&scoped=true"
import script from "./BaseStatusIcon.vue?vue&type=script&lang=js"
export * from "./BaseStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f352e2",
  null
  
)

export default component.exports